import { render } from "./Charts2Border.vue?vue&type=template&id=4c520018&scoped=true"
import script from "./Charts2Border.vue?vue&type=script&lang=js"
export * from "./Charts2Border.vue?vue&type=script&lang=js"

import "./Charts2Border.vue?vue&type=style&index=0&id=4c520018&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c520018"]])

export default __exports__